import { useForm } from "react-hook-form-v5"
import styled, { css } from "styled-components"

import Input from "~/components/atoms/Input"
import ActionPairButton from "~/components/molecules/ActionPairButton"
import { Color, IsMobile, LineHeight, RadiusSize, Shadow, SpacingSize, TextSize } from "~/consts/style-mixins"

interface Props {
  open: boolean
  close: Function
  mainAction: Function
  updateTmpUserInfo: Function
  directApplication?: boolean
}

interface StyledProps {
  open?: boolean
}

const CourseInputPersonalDataModal = ({ open, close, mainAction, updateTmpUserInfo, directApplication }: Props) => {
  const { register, watch, getValues, triggerValidation } = useForm()

  const canProceed = (): boolean => {
    const watchAllFields = watch()
    const emptyField = Object.values(watchAllFields).find((value) => value === "")

    return emptyField === undefined
  }

  return (
    <>
      <StyledDialogWrapper open={open}>
        <StyledDialogHeading>説明会の申込みに必要な情報を入力しましょう</StyledDialogHeading>
        <StyledDialogContent>
          <StyledDialogInput
            name="name"
            size="Medium"
            placeholder="氏名"
            register={register({ required: "氏名を入力してください" })}
          />
          <StyledDialogInput
            type="email"
            name="email"
            size="Medium"
            placeholder="メールアドレス"
            register={register({ required: "メールアドレスを入力してください" })}
          />
        </StyledDialogContent>
        <StyledActionPairButtonWrapper>
          <ActionPairButton
            mainAction={{
              label: directApplication ? "相談会に申し込む" : "希望日時の選択へ",
              action: async () => {
                const validate = await triggerValidation()
                if (validate) {
                  const values = getValues()
                  updateTmpUserInfo({
                    name: values.name,
                    email: values.email,
                  })
                  mainAction()
                }
              },
              disabled: !canProceed(),
            }}
            subAction={{
              label: "キャンセル",
              action: close,
            }}
            vertical
          />
        </StyledActionPairButtonWrapper>
      </StyledDialogWrapper>
      <StyledDialogOverlay open={open} />
    </>
  )
}

const StyledDialogWrapper = styled.div`
  width: calc(100% - 32px);
  max-width: 400px;
  margin: auto;
  padding: ${SpacingSize.XL}px;
  display: none;
  position: fixed;
  top: ${SpacingSize["3XL"]}px;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  ${Shadow.Deep};
  ${({ open }: StyledProps) => css`
    ${open &&
    css`
      display: block;
    `}
  `}
`

const StyledDialogOverlay = styled.div`
  position: fixed;
  z-index: 99;
  top: -25%;
  left: 0;
  bottom: 0;
  right: 0;
  height: 125%;
  width: 100%;
  background: #000;
  display: none;
  opacity: 0.6;
  ${({ open }: StyledProps) => css`
    ${open &&
    css`
      display: block;
    `}
  `}
`

const StyledDialogHeading = styled.div`
  margin-bottom: ${SpacingSize["3XS"]}px;
  font-size: ${TextSize.L}px;
  font-weight: bold;
  line-height: ${LineHeight.S}%;
  .sp-hide {
    ${IsMobile(css`
      display: none;
    `)}
  }
`

const StyledDialogContent = styled.div`
  margin: ${SpacingSize.M}px 0;
`

const StyledDialogInput = styled(Input)`
  width: 100%;
  margin-bottom: ${SpacingSize.XS}px;
`

const StyledActionPairButtonWrapper = styled.div`
  max-width: 320px;
  margin: auto;
  ${IsMobile(css`
    max-width: 280px;
  `)}
  .close {
    text-align: center;
    padding: ${SpacingSize.M}px 0;
  }
`

export default CourseInputPersonalDataModal
